<svg
	xmlns="http://www.w3.org/2000/svg"
	width="24px"
	height="24px"
	viewBox="0 0 24 24"
>
	<rect
		x="2"
		y="4"
		width="20"
		height="18"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		fill="none"
	/>
	<line
		x1="2"
		y1="9"
		x2="22"
		y2="9"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		fill="none"
	/>
	<line
		x1="7"
		y1="2"
		x2="7"
		y2="6"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		fill="none"
	/>
	<line
		x1="17"
		y1="2"
		x2="17"
		y2="6"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		fill="none"
	/>
</svg>
